<template>
  <NavigationHeader :title="wp.title" />
</template>

<script>
export default {
  name: 'AboutCollaborationsHeader',
  inject: ['wp']
}
</script>
